import React, { FC } from 'react';
import { ScreenClassProvider } from 'react-grid-system';
import { AppInitProvider } from './appInitContext';
import { OrderProvider } from './orderContext';
import ProductProvider from './productContext';
import { ReturnProvider } from './returnContext';
import { SettingsProvider } from './settingsContext';
import { TranslationProvider } from './translationContext';

const AppContext: FC = ({ children }) => (
  <ScreenClassProvider>
    <AppInitProvider>
      <SettingsProvider>
        <TranslationProvider>
          <OrderProvider>
            <ProductProvider>
              <ReturnProvider>{children}</ReturnProvider>
            </ProductProvider>
          </OrderProvider>
        </TranslationProvider>
      </SettingsProvider>
    </AppInitProvider>
  </ScreenClassProvider>
);

export default AppContext;
